(function ($, SCS) {
	'use strict';

	var staticResourcesHost = ((($('script[src*=".scsstatic.ch"]:first').attr('src') || '').match(/(\/\/.*scsstatic\.ch)\//) || [])[1] || ''); // find the HOST of the first SCRIPT element with a static resource server OR empty string as fallback

	SCS.Const = {

		SNOOPY_SHARING_URL: 'http://tvonline.swisscom.ch/r/link?', // also used for TV2.0
		SNOOPY_LOADED_EVENT: 'snoopyLoaded',

		SNOOPY_CHANNEL_MAPPING : {
			'sf-1'			: '574b6a53-58bd-488a-a5fe-0d1299854fdd',
			'sf-2'			: 'ee734305-74e6-4bc9-ab1f-c6be80469d5e',
			'sf-info'		: '52404018-4781-4464-8d4c-a4e2f1c9deee',
			'ard'			: 'f2799299-fd05-4b6a-bbfd-719c9db583e2',
			'zdf'			: 'b1435924-aa17-41e6-bb72-e8d95a37a3b9',
			'rtl'			: '364d23b8-2512-4c1c-b268-f9ab56ec3f38',
			'rtl-2'			: 'f89a8a73-4337-4586-bb22-417e88c5ff0d',
			'prosieben'		: 'd1cd8b9b-5572-4686-bc5c-72ed5d9c39be', // no HD available yet
			'sat1'			: 'ae66c5a2-83fe-41e6-9f14-e3ac09218dc1', // no HD available yet
			'kabel-eins'	: '47057ee0-cc86-4dee-8c21-16ef9e693df0', // no HD available yet
			'orf-1'			: '364d23b8-2512-4c1c-b268-f9ab56ec3f38',
			'orf-2'			: 'f89a8a73-4337-4586-bb22-417e88c5ff0d',
			'eurosport'		: 'cc61d18e-348e-4b48-bdbb-c9a95d63193f', // no HD available yet ... and NOT available for web TV!
			'tsr1'			: '8a3a1025-e4f8-47e4-a6e7-22ed6c7942e9',
			'tsr2'			: '83bbb445-ded4-436f-9725-372077fba0a6',
			'tf1'			: '1075f22b-622f-42f8-8721-521a6d4d87fa',
			'm6-suisse'		: '55dd0909-beca-4291-b36d-0790f5ddc128',
			'france-2'		: 'a4875ae5-69ee-462f-9057-5be229947de9',
			'france-3'		: 'c10a3cb6-7e3e-4556-9889-83a1abb10176',
			'france-4'		: '56eaeea5-a2a0-471a-b99f-95567e07430a',
			'rsi-la1'		: '482d5b67-51db-4d2b-900e-8bcd5b73fd29',
			'rsi-la2'		: '3c209535-74c0-40df-b07f-08b5c27470c5',
			'canale-5'		: '1e5f5485-44a8-4c75-8062-051d344d3284', // no HD available yet
			'rai-uno'		: 'bbaa60fd-8200-48f7-8465-d45d3a223082',
			'rai-due'		: 'caf245e5-3111-4a51-9f4b-c0064c2f913a'  // no HD available yet
		},
		SPORT_CHANNELS: {
			'chtv': {
				name: 'CH TV',
				id: 'e623b137-002a-4ac5-b6d2-5b1eefc1cff8'
			},
			'mdr-sachsen': {
				name: 'MDR',
				id: '1a567f8f-3222-43a2-a69b-3f92335134cd'
			},
			'sport1schweiz': {
				name: 'Sport 1',
				id: '4b59eb3a-2aca-4939-809f-74d4d5a8da1a'
			},
			'tv24': {
				name: 'TV 24',
				id: '26b2482f-3b5c-404e-bb68-a38a64174709'
			},
			'more4': {
				name: 'More 4',
				id: 'a58b5205-b1f8-45a4-b23c-cadf431a28cb'
			},
			'canale-5': {
				name: 'Canale 5',
				id: '2681a93a-7344-43d4-b232-b829577134ab'
			},
			'tele1': {
				name: 'tele 1',
				id: 'f1ff8927-4213-47f7-a370-c3e9037ec2fb'
			},
			'servus_tv': {
				name: 'Servus TV',
				id: '1b5a8730-506d-41be-abdc-09124b28ca20'
			},
			'rete-4': {
				name: 'Rete 4',
				id: 'ea1d7cfc-d03f-40bf-96f5-b248445d8baf'
			},
			'm6-suisse': {
				name: 'M6',
				id: '55dd0909-beca-4291-b36d-0790f5ddc128'
			},
			'bbc-one': {
				name: 'BBC 1',
				id: 'dc5bd62c-c1d5-4952-94aa-0b40b3632493'
			},
			'bbc2': {
				name: 'BBC 2',
				id: '9d1820ab-a1a8-4d3d-8ab4-2aa2145eb820'
			},
			'rtlnitro': {
				name: 'RTL Nitro',
				id: '502abd22-ac9a-4bf7-8809-3570c3a96b92'
			},
			'wdr-koeln': {
				name: 'WDR',
				id: 'b1d56065-3cf5-414d-a4c9-4862c4a0cbf6'
			},
			'ndr-niedersachsen': {
				name: 'NDR',
				id: 'a9e3bf20-63c0-4f5b-88e7-a93a907dfcae'
			},
			'br': {
				name: 'BR',
				id: '741f304d-bd8f-42a1-8ac8-fbc08103ad16'
			},
			'swr-fernsehen-bw': {
				name: 'SWR',
				id: 'c8d6571d-15f3-480b-a4ef-c09d70d0427e'
			},
			'rbb': {
				name: 'RBB',
				id: '932aea63-1e98-400c-b87e-e69a77f1c819'
			},
			'3sat': {
				name: '3sat',
				id: '87622996-a63e-4120-9f40-bd16c68707af'
			},
			'sat1gold': {
				name: 'SAT.1 Gold',
				id: 'ba80795b-99d6-4086-b1f2-a041fffc7558'
			},
			'sat1': {
				name: 'SAT.1',
				id: '5e31f6b8-b2fb-499b-87a0-010a4e6d6d14'
			},
			'italia-1': {
				name: 'Italia 1',
				id: 'abe0651e-284a-4e3f-8893-4d9463f241f7'
			},
			'raisports2': {
				name: 'Rai Sport 2',
				id: '6c332a06-dcb0-42f2-abf5-71fc11ca99eb'
			},
			'raisports1': {
				name: 'Rai Sport 1',
				id: 'f884c11d-ab2f-4a29-9520-b0118b66dcd9'
			},
			'rai-tre': {
				name: 'Rai 3',
				id: 'acaf5818-f98e-429e-8490-3a6e281541b8'
			},
			'sf-1': {
				name: 'SRF 1',
				id: '574b6a53-58bd-488a-a5fe-0d1299854fdd'
			},
			'sf-2': {
				name: 'SRF zwei',
				id: 'ee734305-74e6-4bc9-ab1f-c6be80469d5e'
			},
			'ard': {
				name: 'ARD',
				id: 'f2799299-fd05-4b6a-bbfd-719c9db583e2'
			},
			'zdf': {
				name: 'ZDF',
				id: 'b1435924-aa17-41e6-bb72-e8d95a37a3b9'
			},
			'rtl': {
				name: 'RTL',
				id: '9cd31fcd-fe3f-49b8-aa27-ae99231a5c08'
			},
			'rtl-2': {
				name: 'RTL 2',
				id: '6877bf47-2160-461b-b8b9-8767214ad2b3'
			},
			'prosieben': {
				name: 'Pro7',
				id: 'aaa37308-b629-4291-a0eb-1bb61ed17cd0'
			},
			'kabel-eins': {
				name: 'Kabel eins',
				id: 'eada50f7-b603-444b-b5bb-24e25b25a543'
			},
			'startv': {
				name: 'Star TV',
				id: '99cd5709-44d4-4d83-ad75-d066f08aa9fb'
			},
			'orf-1': {
				name: 'ORF 1',
				id: '364d23b8-2512-4c1c-b268-f9ab56ec3f38'
			},
			'orf-2': {
				name: 'ORF 2',
				id: 'f89a8a73-4337-4586-bb22-417e88c5ff0d'
			},
			'dsf': {
				name: 'Sport1',
				id: '6daa7c44-bc40-4502-8923-ead0f0b7d68e'
			},
			'eurosport': {
				name: 'Eurosport',
				id: 'cc61d18e-348e-4b48-bdbb-c9a95d63193f'
			},
			'hr': {
				name: 'HR1',
				id: '9bde57bc-a37d-45fb-9036-6d60416e44cc'
			},
			'itv-1-london': {
				name: 'ITV1',
				id: 'fe3a74b6-77b0-4a9d-8a81-2b810b109d8a'
			},
			'itv-4': {
				name: 'ITV4',
				id: 'f43acfb7-9d7c-4910-b3cf-fc0e9d4bd702'
			},
			'channel-4': {
				name: 'Channel 4',
				id: 'fd18552b-ec44-42d0-a991-d8de6d9dadaa'
			},
			'five': {
				name: 'Five',
				id: 'b7bd1a2b-2e91-413e-904b-1b271b4e72cf'
			},
			'tsr1': {
				name: 'RTS un',
				id: '8a3a1025-e4f8-47e4-a6e7-22ed6c7942e9'
			},
			'tsr2': {
				name: 'RTS deux',
				id: '83bbb445-ded4-436f-9725-372077fba0a6'
			},
			'tf1': {
				name: 'TF1',
				id: '1075f22b-622f-42f8-8721-521a6d4d87fa'
			},
			'france-2': {
				name: 'France 2',
				id: 'a4875ae5-69ee-462f-9057-5be229947de9'
			},
			'france-3': {
				name: 'France 3',
				id: 'a853a4f2-ff63-5200-7048-d8d59d805f7b'
			},
			'france-4': {
				name: 'France 4',
				id: '9553a4f2-ff63-5200-7048-d8d59d805f7e'
			},
			'france-5': {
				name: 'France 5',
				id: '3153a4f2-ff63-5200-7048-d8d59d805f81'
			},
			'rsi-la1': {
				name: 'RSI la 1',
				id: '482d5b67-51db-4d2b-900e-8bcd5b73fd29'
			},
			'rsi-la2': {
				name: 'RSI la 2',
				id: '3c209535-74c0-40df-b07f-08b5c27470c5'
			},
			'rai-uno': {
				name: 'Rai 1',
				id: '65a4d083-50e4-4916-954a-ecd32e48da98'
			},
			'rai-due': {
				name: 'Rai 2',
				id: 'caf245e5-3111-4a51-9f4b-c0064c2f913a'
			},
			'sf-info': {
				name: 'SRF info',
				id: '52404018-4781-4464-8d4c-a4e2f1c9deee'
			}
		},
		SNOOPY_CHANNEL_IMAGE_BASE : '/tvairpub/online/content/images/tv/channel/',
		SNOOPY_CHANNEL_IMAGE_PREFIX_WIDH_SMALL : '_image_W90.png',
		/*
			possible sizes are:
			W45, W90, W116, W145, W176, W290, W484, W928, W1920
			H480, H720, H1080,
		*/

		SNOOPY_SERVICE_PROXY_URL: '/tvairpub/online/',
		SNOOPY_LANGUAGE: $('html').attr('lang') || 'de',
		SNOOPY_IMAGE_WIDTHS: [45, 90, 116, 145, 176, 290, 484, 928, 1920],
		SNOOPY_WEB_RENT_SURCHARGE: 0,
		SNOOPY_VOD_STORES: {'de': 'SwisscomDeutsch', 'fr': 'SwisscomFrançais', 'it': 'SwisscomItaliano', 'en': 'SwisscomDeutsch'},
		SNOOPY_TV_HIGHLIGHTS_CATEGORIES: {'de': 'DeHighlightsTip', 'fr': 'FrHighlightsTip', 'it': 'ItHighlightsTip', 'en': 'EnHighlightsTip'},
		SNOOPY_IS_OLD_IE: (Number((navigator.userAgent.toLowerCase().split('msie')[1] || '').split('.', 1)[0] || 9) < 9), // check if is IE and version is < 9

		STATIC_RESOURCES_HOST: staticResourcesHost,
		SNOOPY_IMAGE_BASE: staticResourcesHost + '/tvairpubimage/',

		SNOOPY_REPLAY_MAX_HOURS: 30
	};

}(window.jQuery, window.SCS = window.SCS || {}));



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/js/SCS.Const.js
// module id = 75
// module chunks = 0